<template>
  <div class="home-content-page-v">
    <div class="content-one">
      <content-title :title="'数据源 ' + preDay + ''" :actions="titleAction" @clickMenu="clickTitleMenu"></content-title>
      <div class="output-content">
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>进销存数据 <i class="iconfont icon-checked suc-iconfont" v-if="inputJxcOk"></i></span>
            <input type="file" @change="oldFileChange" :disabled="inputJxcOk" id="file-1" v-if="!inputJxcOk">
            <div class="input-note-info" v-if="inputJxcOk">昨日进销存数据已导入</div>
          </div>
        </div>
        <div class="m-line">
        </div>
        <!-- <div class="output-content-1">
          <div class="checkbox-content">
            <span>油库指标 <i class="iconfont icon-checked suc-iconfont" v-if="inputDepotValumeOk"></i></span>
            <input type="file" @change="stationFileChange" :disabled="inputDepotValumeOk" id="file-3" v-if="!inputDepotValumeOk">
            <div class="input-note-info" v-if="inputDepotValumeOk">油库指标已导入</div>
          </div>
        </div>
        <div class="m-line">
        </div> -->
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>今日配送计划 <i class="iconfont icon-checked suc-iconfont" v-if="inputOrderPlantOk"></i></span>
            <input type="file" @change="plantFileChange" :disabled="inputOrderPlantOk" id="file-4" v-if="!inputOrderPlantOk">
            <div class="input-note-info" v-if="inputOrderPlantOk">今日配送计划已导入</div>
          </div>
        </div>
        <div class="m-line">
        </div>
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>要货量 <i class="iconfont icon-checked suc-iconfont" v-if="inputToGoodsOk"></i></span>
            <input type="file" @change="toGoodsFileChange" :disabled="inputToGoodsOk" id="file-5" v-if="!inputToGoodsOk">
            <div class="input-note-info" v-if="inputToGoodsOk">今日要货量已导入</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="要货导入异常数据" :visible.sync="showYHerror">
      <mii-base-table :datas="toGoodsErrorData" :table_style="2" :ths="ths"></mii-base-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showYHerror = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="要货导入数据统计" :visible.sync="showYHcount">
      <mii-base-table :datas="toGoodsCount" :table_style="2" :ths="thsC"></mii-base-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showYHcount = false">关 闭</el-button>
      </div>
    </el-dialog>
    <div style="display: none">
      {{toGoodsErrorData}}{{toGoodsCount}}
    </div>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      showYHcount: false,
      showYHerror: false,
      titleAction: [{
        key: 'his',
        icon: 'icon-meitian'
      }],
      thsC: [{
        label: '油品名称',
        key: '油品名称'
      },
      {
        label: '总条数',
        key: 'count'
      },
      {
        label: '总吨数',
        key: 'total'
      }],
      ths: [{
        label: '加油站代码',
        key: '加油站代码'
      },
      {
        label: '92#',
        key: '92#'
      },
      {
        label: '95#',
        key: '95#'
      },
      {
        label: '98#',
        key: '98#'
      },
      {
        label: '0#',
        key: '0#'
      },
      {
        label: '备注',
        key: '备注'
      },
      {
        label: '错误',
        key: '错误'
      }]
    }
  },
  methods: {
    clickTitleMenu (key) {
      if (key === 'his') {
        this.$router.push({'name': 'single.input_data_date'})
      }
    },
    checkFile (files) {
      if (!files.length) {
        return null
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0]
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        })
        return false
      }
    },
    oldFileChange (e) {
      let fileOld = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!fileOld) {
        document.getElementById('file-1').value = ''
      } else {
        this.$store.dispatch('dealJxcExceldata', {excelFile: fileOld, fileId: 'file-1'})
      }
    },
    plantFileChange (e) {
      let filePlant = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!filePlant) {
        document.getElementById('file-4').value = ''
      } else {
        this.$store.dispatch('inputOlderPlan', {excelFile: filePlant, fileId: 'file-4'})
      }
    },
    toGoodsFileChange (e) {
      let filePlant = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!filePlant) {
        document.getElementById('file-5').value = ''
      } else {
        this.$store.dispatch('inputToGoods', {excelFile: filePlant, fileId: 'file-5'})
      }
    },
    stationFileChange (e) {
      let fileStation = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!fileStation) {
        document.getElementById('file-3').value = ''
      } else {
        this.$store.dispatch('inputDepotValume', {excelFile: fileStation, fileId: 'file-3'})
      }
    }
  },
  computed: {
    toGoodsErrorData: {
      get () {
        let data = this.$store.getters.toGoodsErrorData
        this.showYHerror = data.length > 0
        return data
      }
    },
    toGoodsCount: {
      get () {
        let data = this.$store.getters.toGoodsCount
        this.showYHcount = data.length > 0
        return data
      }
    },
    preDay: {
      get () {
        return this.$store.getters.todayStr
      }
    },
    inputJxcOk: {
      get () {
        return this.$store.getters.inputJxcOk
      }
    },
    inputOrderPlantOk: {
      get () {
        return this.$store.getters.inputOrderPlantOk
      }
    },
    inputToGoodsOk: {
      get () {
        return this.$store.getters.inputToGoodsOk
      }
    },
    inputDepotValumeOk: {
      get () {
        return this.$store.getters.inputDepotValumeOk
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.input-note-info {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: #999;
}
.content-one {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 2em;
}
.output-btn {
  align-self: flex-end;
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content {
  flex:1;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  padding: 2em;
  min-height: 22em;
  background-color: #fff;
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.m-line {
  width: 2px;
  background-color: #ccc;
  margin: 1.5em 2.2em 1.5em 0;
}
.output-content-1 {
  flex: 1;
  margin: 1em 2.5em 1em;
  display: flex;

}
.checkbox-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .iconfont {
    margin-left: 1rem;
  }
  .error-iconfont {
    color: @color-warning;
  }
  .suc-iconfont {
    line-height: 1;
    color: @color-suc;
  }
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
  input {
    margin-top: 2rem;
  }
}

.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// source_data_pre.vue?5dacf5c8